import _ from 'lodash';
import template from './odabirPozicijaForm.html';
import {kvadrant_I} from './kvadrant.js';
import {kvadrant_II} from './kvadrant.js';
import {kvadrant_III} from './kvadrant.js';
import {kvadrant_IV} from './kvadrant.js';

class OdabirPozicijaFormController {
    constructor() {
        this.item = this.resolve.item;
        this.kvadranti = [];
    }

    $onInit() {
        this.clone = angular.copy(this.item);

        this.kvadranti = [
            _.cloneDeep(kvadrant_I),
            _.cloneDeep(kvadrant_II),
            _.cloneDeep(kvadrant_III),
            _.cloneDeep(kvadrant_IV),
        ];

        this.kvadranti.map((kvadrant) => {
            kvadrant.map((pozicija) => {
                const item = _.find(this.clone.pozicije, {broj: pozicija.broj});
                pozicija.selected = _.isUndefined(item) ? false: true;
            });
        });

        if(_.isArray(this.clone.pozicije) === false) {
            this.clone.pozicije = [];
        }
    }


    submit() {
        let pozicije = [];
        this.kvadranti.map((kvadrant) => {
            kvadrant.map((pozicija) => {
                if(pozicija.selected){
                    pozicije.push({broj: pozicija.broj, selected: pozicija.selected});
                }
            });
        });
        this.close({$value: pozicije});
    };

    pozicijaClicked(pozicija) {

        this.kvadranti.map((kvadrant) => {
            kvadrant.map((item) => {
                if(item.broj === pozicija.broj){
                    pozicija.selected = !pozicija.selected;
                }
            });
        });
        this.submit();
    }

    cancel() {
        this.dismiss({$value: 'cancel'});
    };
}

OdabirPozicijaFormController.$inject=[];

const OdabirPozicijaFormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: OdabirPozicijaFormController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};

export {OdabirPozicijaFormComponent};
export {OdabirPozicijaFormController};



// WEBPACK FOOTER //
// ./app/components/stavkaNaloga/odabirPozicijaForm.component.js